import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import React, { useMemo, useCallback } from 'react';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';

export interface ConfigureWriteBackModeProps {
  mode: WorkflowWriteBackMode | null;
  updateMode: (details: WorkflowWriteBackMode | null) => void;
}

export const ConfigureWriteBackMode = ({
  mode,
  updateMode,
}: ConfigureWriteBackModeProps) => {
  const selected: WorkflowWriteBackMode = useMemo(
    () => mode ?? 'no-writeback',
    [mode],
  );

  const list = useMemo(
    () => [
      { optionLabel: 'Normal', optionValue: 'normal' },
      { optionLabel: 'No Upstream', optionValue: 'no-upstream' },
      { optionLabel: 'No Writeback', optionValue: 'no-writeback' },
    ],
    [],
  );

  const setFn = useCallback(
    (selected: WorkflowWriteBackMode) => {
      updateMode(selected);
    },
    [updateMode],
  );

  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <label className="block text-sm font-medium text-gray-700">
        Select write back mode (debug modes)
      </label>
      <SelectBoxWithSearch
        type="single"
        selected={selected}
        list={list}
        setSelected={setFn}
        label={'Write Back Mode'}
      />
    </div>
  );
};
